import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTriangleExclamation } from "@fortawesome/free-solid-svg-icons";
import Button from "../../atoms/Buttons/Button/Button";

const supportEmail = process.env.REACT_APP_SUPPORT_EMAIL;

// Shown to users whose organisation has been deactivated.
const OrganisationDeactivatedNotice = () => {
  const handleContactSupport = () => {
    window.location.href = `mailto:${supportEmail}`;
  };

  return (
    <div className="organisation-deactivated-notice" role="alert">
      <FontAwesomeIcon
        icon={faTriangleExclamation}
        className="organisation-deactivated-notice__icon"
      />
      <div className="organisation-deactivated-notice__content">
        <h5>Organisation Deactivated</h5>
        <p>
          Your organisation is currently deactivated. Access to Erniee features
          has been temporarily restricted.
          <br />
          You can still access your profile and account settings. Please
          contact your Organisation Administrator or Erniee Support for
          assistance.
        </p>
      </div>
      {supportEmail && (
        <Button
          text="Contact Support"
          cssClass="btn-secondary organisation-deactivated-notice__action"
          onClick={handleContactSupport}
        />
      )}
    </div>
  );
};

export default OrganisationDeactivatedNotice;
